import React from 'react';

const Loading = () => (
  <div className="loading">
    <i className="fa fa-circle-o-notch fa-spin fa-fw"/>
  </div>
);

export default Loading;
